import { Modal } from './client/components/common/Modal/Modal';
import { Frame } from './client/components/common/Frame';
import * as React from 'react';
import { Button, ButtonType } from './client/components/common/Button/Button';
import './Preview.scss';
import { l } from './client/Other/Translation';
import { LabelKeys } from './client/Interfaces/LabelsInterface';

export interface PreviewProps {
  html: string;
  isOpen: boolean;
  close: () => void;
  openPdfWindow: () => void;
  downloadPDF: () => Promise<boolean>;
}

const PreviewHeader: React.FunctionComponent<{
  html: string, openPdfWindow, downloadPDF, close
}> = ({ openPdfWindow, downloadPDF, close }) => {
  const [downloading, setIsDownloading] = React.useState(false);
  return <div className="header">
    <div className="title">
      {l('invoice.preview')}
    </div>
    <Button
      type={ButtonType.accept}
      label={l(LabelKeys.invoice.buttons.pdf)}
      showLoadingAnimation={downloading}
      action={async () => {
        setIsDownloading(true);
        await downloadPDF();
        setIsDownloading(false);
      }}
    />
    <Button
      type={ButtonType.normal}
      label={l('Close')}
      action={() => close()}
    />
  </div>;
};

export const Preview: React.FunctionComponent<PreviewProps> = ({ html, isOpen, close, downloadPDF, openPdfWindow }) => {
  return (
    <Modal
      headerJSX={<PreviewHeader html={html} openPdfWindow={openPdfWindow} downloadPDF={downloadPDF} close={close} />}
      closeOnOverlayClick={true}
      isOpen={isOpen}
      onClose={() => close()}
      showCloseIcon={false}
      className={'Preview'}
    >
      <Frame style={{ height: '1130px', width: '100%', border: 'none' }}>
        {html}
      </Frame>
    </Modal>
  );
};
